export default __webpack_public_path__ + "static/media/Isometric_Square_raspberry.8161bcda.svg";